<template>
  <div>
    <LayoutTitle :title="item.groupName" v-for="(item, index) in dynamicList" :key="item.groupId">
      <FormLayout
        ref="projectForm" 
        :readOnly="readOnly"
        :model="projectInfo"
        :list="generatePage(index)"
        @on-change-tree="checkMember"
        @on-change-all="checkPerson">
      </FormLayout>
    </LayoutTitle>
  </div>
</template>

<script>
import {timeFormat} from '@/utils'
import generateList from './generate-form'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import { submitApprProjectSignUp, getApprProjectSignUp, editApprProjectSignUp } from '../../interface'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      projectInfo: {},
      dictMap: {},
      formLayout: [],
      groupId: '',
      dynamicList: []
    }
  },
  created () {
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    const idMap = JSON.parse(sessionStorage.getItem('idMap'))
    this.orgId = this.$decode(sessionStorage.getItem(idMap[this.bizLineCode]))
    this.readOnly = this.$decode(this.$route.query.type) == 'see'
  },
  inject: ['getApplicationObjectId'],
  methods: {
    //生成表单和表格
    generatePage (index) {
      return generateList.call(this, index)
    },
    //重置表单校验
    resetFields () {
      if (Array.isArray(this.$refs.projectForm)) {
        this.$refs.projectForm.every(ref => {
          ref.resetFields()
        })
      } else {
        this.$refs.projectForm.resetFields()
      }
    },
    //转换对应的值
    transferDataType () {
      if (!this.dynamicList.length) return
      this.dynamicList.forEach((item) => {
        item.formPropertyList.forEach(val => {
          const value = this.projectInfo[val.propertyCode]
          if (val.widgetType == 'InputNumber') {
            this.$set(this.projectInfo, val.propertyCode, value ?? null)
          }
          if (val.widgetType == 'DatePicker') {
            this.$set(this.projectInfo, val.propertyCode, value ? timeFormat(value) : '')
          }
        })
      })
    },
    //获取信息
    async getPersonInfo (params) {
      this.getCodeTable('BOE68')
      await this.getCodeTable('BOE15')
      await this.getCodeTable('KZ41')
      this.projectInfo = {}
      if (params) {
        // this.readOnly = !params.isReportState
        this.projectInfo.projPartyOrgMemberNum = null
        this.projectInfo.projPartyOrgWorkerNum = null
        this.projectInfo.projProgress = null
        getApprProjectSignUp({signUpId: params.signUpId, orgId: params.orgId}).then(({data}) => {
          if (params.quickFill) {
            data.isCancel = '0'
          }
          let isCancel = data.isCancel
          this.readOnly = isCancel == '1'
          this.projectInfo = { ...this.projectInfo, ...data }
          this.projectInfo.projCompletionTime = timeFormat(this.projectInfo.projCompletionTime)
          this.projectInfo.projEstablishmentTime = timeFormat(this.projectInfo.projEstablishmentTime)
          // this.projectInfo.projLeaderName = [{
          //   userId: this.projectInfo.projLeaderId,
          //   userName: this.projectInfo.projLeaderName
          // }]
          //设置附件
          if (this.projectInfo.attachmentGroupId) {
            this.groupId = this.projectInfo.attachmentGroupId
            this.getActivityFiles(this.groupId).then(data => {
              this.$set(this.projectInfo, 'uploadFile', data)
            })
          } else {
            this.groupId = this.getUuid()
          }
          this.$emit('on-request', {
            ...data,
            isCancel: isCancel
          })
          //动态表单
          this.dynamicList = this.list
          this.transferDataType()
        })
      } else {
        this.readOnly = false
        this.groupId = this.getUuid()
        //动态表单
        this.dynamicList = this.list
        this.transferDataType()
      }
    },
    judgeRefs () {
      let refs = this.$refs.projectForm
      if (!Array.isArray(refs)) {
        refs = [this.$refs.projectForm]
      }
      const req = refs.map(ref => ref.validateify())
      return req
    },
    //将date对象格式化
    dateFormat (obj) {
      Object.keys(obj).forEach(item => {
        if (obj[item] instanceof Date) {
          obj[item] = timeFormat(obj[item])
        }
      })
      return obj
    },
    //提交
    submitPersonInfo (recommendInfo) {
      const applicationObjectId = this.getApplicationObjectId()
      Promise.all(this.judgeRefs()).then(res => {
        const result = res.every(v => v)
        if (!result) {
          this.$emit('on-close', 'valid')
          this.$Message.error('表单校验失败')
          return
        }
        const requestMethod = recommendInfo.signUpId ? editApprProjectSignUp : submitApprProjectSignUp
        const params = this.dateFormat({
          ...recommendInfo,
          ...this.projectInfo,
          // projLeaderId: this.projectInfo.projLeaderName[0].userId,
          // projLeaderName: this.projectInfo.projLeaderName[0].userName,
          attachmentGroupId: this.groupId,
          applicationObjectId: applicationObjectId
        })
        requestMethod(params, {
          headers: {
            'Content-Type': 'application/json'
          },
          disabledData: true
        }).then(({data}) => {
          this.$Message.success('提交成功')
          if (!recommendInfo.signUpId) {
            let type = 'addType' //修改
            this.$emit('on-request', {
              ...recommendInfo,
              signUpId: data.signUpId
            }, type) //修改
          } else {
            this.$emit('on-close')
          }
        }).catch(() => {
          this.$emit('on-close', 'valid')
        })
      })
    },
    checkMember (data, key) {
      if (key == 'projPartyOrgName') {
        this.$set(this.projectInfo, 'projPartyOrgId', data[0].id || '')
        this.$set(this.projectInfo, 'projPartyOrgName', data[0].orgName || '')
      }
      if (data.userId) {
        this.$ajax({
          url: 'api-uum/uuminfo/getUserInfoByCode',
          method: 'GET',
          data: {
            userId: data.userId
          }
        }).then(({data}) => {
          this.$set(this.projectInfo, 'projLeaderName', data.data.userName || '')
          this.$set(this.projectInfo, 'projLeaderId', data.data.userCode || '')
          this.$set(this.projectInfo, 'projLeaderJobNumber', data.data.userCode || '')
          this.$set(this.projectInfo, 'projLeaderEmail', data.data.email || '')
          this.$set(this.projectInfo, 'projLeaderAdminPost', data.data.dutyCode || '')
          this.$set(this.projectInfo, 'projLeaderPartyPost', data.data.positionNames || '')
        })
      }
    },
    // 选人
    checkPerson ([item]) {
      // this.$set(this.projectInfo, 'projLeaderJobNumber', item.userCode || '')
      // this.$set(this.projectInfo, 'projLeaderEmail', item.email || '')
      this.$set(this.projectInfo, 'projLeaderAdminPost', item.hrDuty || '')
      const keys = Object.keys(item.partyDuty)
      if (keys.length > 0) {
        this.$set(this.projectInfo, 'projLeaderPartyPost', item.partyDuty[keys[0]] || '')
      } else {
        this.$set(this.projectInfo, 'projLeaderPartyPost', '')
      }
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  },
  components: {
    FormLayout,
    LayoutTitle
  }
}
</script>